import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./pages/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker: only register in production; in development, unregister existing SWs
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            newWorker.addEventListener("statechange", () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                if (
                  window.confirm(
                    "Шинэ хувилбар бэлэн байна. Хуудас шинэчлэх үү?"
                  )
                ) {
                  window.location.reload();
                }
              }
            });
          });
        })
        .catch((registrationError) => {
          console.error("SW registration failed: ", registrationError);
        });
    });
  } else {
    // Development: ensure any previously registered SWs are unregistered to avoid stale caches
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch((err) => {
        console.error("SW unregister failed: ", err);
      });
  }
}

// PWA install prompts only in production
if (process.env.NODE_ENV === "production") {
  let deferredPrompt;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;

    const installButton = document.createElement("button");
    installButton.textContent = "📱 App суулгах";
    installButton.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: #3b82f6;
      color: white;
      border: none;
      padding: 12px 20px;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      z-index: 1000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;

    installButton.addEventListener("click", () => {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        deferredPrompt = null;
        installButton.remove();
      });
    });

    document.body.appendChild(installButton);

    setTimeout(() => {
      if (installButton.parentNode) {
        installButton.remove();
      }
    }, 10000);
  });

  window.addEventListener("appinstalled", () => {
    const installButton = document.querySelector(
      'button[style*="position: fixed"]'
    );
    if (installButton) {
      installButton.remove();
    }
  });
}
